import { render, staticRenderFns } from "./TrademarkBulletinAnalyseReport.vue?vue&type=template&id=4800a4e1&"
import script from "./TrademarkBulletinAnalyseReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkBulletinAnalyseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports